//import fabric from './fabric.require'
import $pageConfig from 'webutils/services/page-config';
import fabric from 'fabric';
const FI = fabric.Image;

fabric.layerDefaults = {
    lockScalingFlip: true,
    perPixelTargetFind: true,
    targetFindTolerance: 40,
    cornerSize: $pageConfig.touch ? 20 : 13,
    transparentCorners: true,
    borderColor: 'red',
    cornerColor: 'red',
    toSvgDataUrl() {
        return 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewbox="' + this.left + ' ' + this.top + ' ' + this.width + ' ' + this.height + '">' + this.toSVG() + '</svg>');
    }
};

let utils = {
    scaleToFit(from, to, overscan) {
        let size = { width: from.width, height: from.height, overscan: from.overscan };

        if (from.width > to.width || from.height > to.height) {
            size.widthRatio = to.width / size.width;
            size.heightRatio = to.height / size.height;
            size.multiplier = size.zoom = Math[overscan ? 'max' : 'min'](size.widthRatio, size.heightRatio);
            size.width = size.width * size.zoom;
            size.height = size.height * size.zoom;
            size.overscan = size.overscan * size.zoom;
        } else {
            size.multiplier = size.zoom = 1.0;
        }
        return size;
    },
    getDimensions(obj) {
        return { width: obj.getWidth(), height: obj.getHeight() };
    },
    greatestCommonDivisor(d) {
        function gcd(a, b) {
            //console.log('gcd', a, b);
            return b ? gcd(b, a % b) : a;
        };
        let result = gcd(d.width, d.height);
        return { width: d.width / result, height: d.height / result, result: result };
    },
    colorStylecolorStyle(color) {
        return color === 'rgba(0,0,0,0)' ? 'url(//emuncloud-staticassets.s3.amazonaws.com/transparent_swatch.gif)' : color;
    },
    parseCSS(css) {
        let rules = {};
        css = utils.removeCssComments(css);
        let blocks = css.split('}');
        blocks.pop();
        let len = blocks.length;
        for (let i = 0; i < len; i++) {
            let pair = blocks[i].split('{');
            rules[pair[0].trim()] = utils.parseCSSBlock(pair[1]);
        }
        return rules;
    },
    parseCSSBlock(css) {
        let rule = {};
        let declarations = css.split(';');
        declarations.pop();
        let len = declarations.length;
        for (let i = 0; i < len; i++) {
            let loc = declarations[i].indexOf(':');
            let property = declarations[i].substring(0, loc).trim();
            let value = declarations[i].substring(loc + 1).trim();

            if (property != "" && value != "")
                rule[property] = value;
        }
        return rule;
    },
    removeCssComments(css) {
        return css.replace(/\/\*(\r|\n|.)*\*\//g, "");
    },
    //http://jsfiddle.net/pagameba/jjLe9wps/
    clipTo(d, o, ctx){       
        o.setCoords();
        let clipRect = {
            width: d.width,
            height: d.height,
            left: 0,
            top: 0,
            strokeWidth: 0
        };
        let scaleXTo1 = (1 / o.scaleX);
        let scaleYTo1 = (1 / o.scaleY);
        ctx.save();

        let ctxLeft = -(o.width / 2) + clipRect.strokeWidth;
        let ctxTop = -(o.height / 2) + clipRect.strokeWidth;
        let ctxWidth = clipRect.width - clipRect.strokeWidth;
        let ctxHeight = clipRect.height - clipRect.strokeWidth;

        ctx.translate(ctxLeft, ctxTop);
        ctx.rotate(o.angle * -1 * Math.PI / 180);
        ctx.scale(scaleXTo1, scaleYTo1);

        let x = o.canvas.viewportTransform;

        ctx.scale(1 / x[0], 1 / x[3]);
        ctx.translate(x[4], x[5]);

        ctx.beginPath();

        ctx.rect(
            x[0] * clipRect.left - o.oCoords.tl.x,
            x[3] * clipRect.top - o.oCoords.tl.y,
            x[0] * clipRect.width,
            x[3] * clipRect.height);
        ctx.closePath();
        ctx.restore();
    }
};


//http://jsfiddle.net/9ms04sfs
FI.filters.Trapezoid = fabric.util.createClass(FI.filters.BaseFilter, {
    type: 'Trapezoid',
    factor: 50,
    direction: 'left',
    mainParameter: 'factor',
    applyTo(canvasEl) {
        const me = this;
        if(me.factor == 0 || ['top','bottom','left','right'].indexOf(me.direction) === -1) return;
        const cln = fabric.util.createCanvasElement();
        const ctx = canvasEl.getContext('2d');
        me.width = cln.width = canvasEl.width;
        me.height = cln.height = canvasEl.height;
        cln.getContext('2d').drawImage(canvasEl, 0, 0);
        ctx.clearRect(0, 0, me.width, me.height);
        switch (me.direction) {
            case 'top':
                return me.drawTrapezoidY(ctx, cln, false);
            case 'bottom':
                return me.drawTrapezoidY(ctx, cln, true);
            case 'left':
                return me.drawTrapezoidX(ctx, cln, false);
            case 'right':
                return me.drawTrapezoidX(ctx, cln, true);
        }
    },
    drawTrapezoidY(ctx, img, inverse) {
        const me = this;
        var startPoint = me.width * 0.5 * (me.factor * 0.01);
        var xi, xf;

        for (var y = 0; y < me.height; y++) {
            xf = inverse ? (me.height - y) : y;
            xi = startPoint - (startPoint * xf / me.height);
            ctx.drawImage(img, 0, y, me.width, 1, xi, y, me.width - xi * 2, 1);
        }
    },
    drawTrapezoidX(ctx, img, inverse) {
        const me = this;
        var startPoint = me.height * 0.5 * (me.factor * 0.01);
        var yi, yf;

        for (var x = 0; x < me.width; x++) {
            yf = inverse ? (me.width - x) : x;
            yi = startPoint - (startPoint * yf / me.width);
            ctx.drawImage(img, x, 0, 1, me.height, x, yi, 1, me.height - yi * 2);
        }
    },
    toObject() {
        return { 
            type: this.type,
            factor: this.factor,
            direction: this.direction
        };
    },
});

FI.filters.Trapezoid.fromObject = FI.filters.BaseFilter.fromObject;

Object.assign(fabric.Object.prototype, fabric.layerDefaults);
Object.assign(fabric, utils);
Object.assign(fabric.util, utils);

export default fabric;